module.exports = __webpack_public_path__ + "img/select-arrow.cd1d552d.svg";